import { DashboardGetters } from './partials/dashboard'
import { DocketEntryEditGetters } from './partials/docket-entry-edit'
import { PrintGetters } from './partials/print'
import { UploadLinksGetters } from './partials/upload-links'

export const DocketEntryGetters = {
  ...DashboardGetters,
  ...DocketEntryEditGetters,
  ...PrintGetters,
  ...UploadLinksGetters,

  docketEntry: state => state.docketEntry,
  docketEntryType: state => state.docketEntryType,
}
